export function openKiosk() {
  const url = `${window.location.origin}/asistencia`;
  const win = window.open(url, "_blank");
  if (!win) {
    window.location.href = url;
  }
}
